import React, { useRef, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Images, X } from "lucide-react";
import { resolveImageUrl } from "../context/AppSettingsContext";

// Fotogallery della sede (usata nella Landing circuito): upload multiplo + rimozione
export function BranchGallery({ branch, onChanged }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const gallery = branch.gallery || [];
  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    try {
      const urls = [...gallery];
      for (const file of Array.from(files).slice(0, 12 - gallery.length)) {
        const fd = new FormData(); fd.append("file", file); fd.append("kind", "branch");
        const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      }
      await api.patch(`/branches/${branch.id}`, { gallery: urls });
      toast.success("Fotogallery aggiornata"); onChanged();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async (url) => {
    try { await api.patch(`/branches/${branch.id}`, { gallery: gallery.filter((u) => u !== url) }); onChanged(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="space-y-1.5" data-testid={`branch-gallery-${branch.id}`}>
      <div className="flex items-center justify-between text-[11px] text-zinc-400"><span className="inline-flex items-center gap-1"><Images className="h-3 w-3" /> Fotogallery landing · {gallery.length}/12</span>
        <button type="button" disabled={busy || gallery.length >= 12} onClick={() => ref.current?.click()} className="text-sky-700 font-semibold hover:underline disabled:opacity-50" data-testid={`branch-gallery-add-${branch.id}`}>{busy ? "Carico…" : "+ Aggiungi foto"}</button>
      </div>
      <input ref={ref} type="file" multiple accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files)} data-testid={`branch-gallery-file-${branch.id}`} />
      {gallery.length > 0 && (
        <div className="flex gap-1.5 overflow-x-auto pb-1">
          {gallery.map((u) => (
            <div key={u} className="relative h-14 w-20 shrink-0 rounded-lg overflow-hidden ring-1 ring-zinc-700">
              <img src={resolveImageUrl(u)} alt="" className="h-full w-full object-cover" onError={(e) => { e.currentTarget.style.opacity = "0.2"; }} />
              <button type="button" onClick={() => remove(u)} className="absolute top-0.5 right-0.5 h-4 w-4 rounded-full bg-black/70 text-white flex items-center justify-center" aria-label="Rimuovi" data-testid="branch-gallery-remove"><X className="h-3 w-3" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
